import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AppleApplicationEffects } from './apple-applications.effects';
import { appleApplicationReducer } from './apple-applications.reducer';
import { UploadService } from './upload.service';

export const provideAppleApplicationsStore = () => [
  provideState('apple-applications', appleApplicationReducer),
  provideEffects([AppleApplicationEffects]),
  UploadService,
];
